// extracted by mini-css-extract-plugin
export default {"questions":"uj2Zy","list":"f2IiN","no-questions":"dC6W0"};